import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enUS from './en-US.json'
import zhCN from './zh-CN.json'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'en-US',
  messages: {
    'en-US': Object.assign({}, enUS),
    'zh-CN': Object.assign({}, zhCN)
  }
})

export default i18n
